import { create } from "zustand";
import { persist } from "zustand/middleware";
import { hasValidSession } from "../utils/session";

type State = {
  token: string | null;
  user: any;
};

type Actions = {
  setToken: (token: string | null) => void;
  setUser: (user: any) => void;
};

export const useAuthStore = create<State & Actions>()(
  persist<State & Actions>(
    (set) => ({
      token: hasValidSession() ? "true" : null,
      user: null,
      setToken: (token: string | null) => set({ token: token }),
      setUser: (user: any) => set({ user }),
    }),
    {
      name: "auth-store",
      onRehydrateStorage: () => (state) => {
        if (hasValidSession()) {
          state?.setToken("true");
        }
      },
    },
  ),
);

/**
 * Global settings object type declaration
 */
export interface GlobalSettingsType {
  DEFAULT_PAGE: number;
  DEFAULT_PAGE_SIZE: number;
  ENABLE_2FA_MAIL: boolean;
  ENABLE_FACEBOOK: boolean;
  ENABLE_GOOGLE: boolean;
  ENABLE_RECAPTCHA: boolean;
  RECAPTCHA_SITE_KEY: string;
  MAX_PTT_TIMEOUT: number;
}

// Your GlobalSettings class
export class GlobalSettings implements GlobalSettingsType {
  DEFAULT_PAGE: number = 0;
  DEFAULT_PAGE_SIZE: number = 0;
  ENABLE_2FA_MAIL: boolean = false;
  ENABLE_FACEBOOK: boolean = false;
  ENABLE_GOOGLE: boolean = false;
  ENABLE_RECAPTCHA: boolean = false;
  RECAPTCHA_SITE_KEY: string = "";
  MAX_PTT_TIMEOUT = 1;
}

// Define the Zustand store interface
interface SettingState {
  settings: GlobalSettings;
  setSettings: (settings: GlobalSettings) => void;
}

// Create the store
export const useSettingStore = create<SettingState>((set) => ({
  settings: new GlobalSettings(),
  setSettings: (settings: GlobalSettings) => set({ settings }),
}));
